<template>
  <span>{{ translatedText }}</span>
</template>

<script>
import { translator } from '@/plugins/i18n'

export default {
  name: 'TranslateText',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      translatedText: this.text
    }
  },
  async mounted() {
    await this.translateText()
  },
  methods: {
    async translateText() {
      const lang = translator.getLanguage()
      if (lang === 'en') {
        this.translatedText = this.text
        return
      }

      try {
        this.translatedText = await translator.translate(this.text, lang)
      } catch (error) {
        console.error('Translation error:', error)
        this.translatedText = this.text
      }
    }
  },
  watch: {
    text: {
      handler() {
        this.translateText()
      },
      immediate: false
    }
  }
}
</script>